<template>
    <div style="min-width:1290px;">
      <MyBanner />
      <div>
        <div class="w1200">
          <div style="padding:20px 0;">
            <el-breadcrumb :separator-icon="ArrowRight">
              <el-breadcrumb-item>当前位置：</el-breadcrumb-item>
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>{{Factive}}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="content">
            <div class="box-content">
              <el-table :data="concealedWorkList" stripe style="width: 100%">
                <el-table-column prop="projectName" label="工程名称" width="200px" align="left" header-align="center">
                  <template #default="{ row }">
                    <el-tooltip 
                      :content="row.projectName" 
                      placement="top" 
                    >
                      <div class="multi-line-ellipsis">{{ row.projectName }}</div>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="concealedContent" label="部位及隐蔽内容" width="300px" align="left" header-align="center">
                  <template #default="{ row }">
                    <el-tooltip 
                      :content="row.concealedContent" 
                      placement="top" 
                    >
                      <div class="multi-line-ellipsis">{{ row.concealedContent }}</div>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="standardBasis" label="设计要求和施工规范依据" align="left" header-align="center">
                  <template #default="{ row }">
                    <el-tooltip 
                      :content="row.standardBasis" 
                      placement="top" 
                    >
                      <div class="multi-line-ellipsis">{{ row.standardBasis }}</div>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="timeAndLocation" label="验收时间和地点" align="left" header-align="center">
                  <template #default="{ row }">
                    <el-tooltip 
                      :content="row.timeAndLocation" 
                      placement="top" 
                    >
                      <div class="multi-line-ellipsis">{{ row.timeAndLocation }}</div>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="participatingUnitsAndPersonnel" label="验收参与单位及人员" align="left" header-align="center">
                  <template #default="{ row }">
                    <el-tooltip 
                      :content="row.participatingUnitsAndPersonnel" 
                      placement="top" 
                    >
                      <div class="multi-line-ellipsis">{{ row.participatingUnitsAndPersonnel }}</div>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="apUploadifyQueryBOList" width="100px" label="验收过程记录" align="center" header-align="center">
                    <template #default="{ row }">
                        <span v-if="row.apUploadifyQueryBOList[0].newName.split('.')[1] == 'pdf'">
                            <a @click="previewFile(row.tenderSystemAddress + '/onlineS/upload/' + row.apUploadifyQueryBOList[0].path)" style="color:#409EFF;">预览</a>
                            <!-- <a :href="row.tenderSystemAddress + '/sino/api/ap/uploadify/downloadAttachment?aulId=' + row.apUploadifyQueryBOList[0].aulId" style="color:#409EFF;">下载</a> -->
                        </span>
                        <span v-else>
                            <el-image
                                style="width: 95px; height: 65px"
                                :src="row.tenderSystemAddress + '/onlineS/upload/' + row.apUploadifyQueryBOList[0].path"
                                :preview-src-list="[row.tenderSystemAddress + '/onlineS/upload/' + row.apUploadifyQueryBOList[0].path]"
                                :preview-teleported="true">
                            </el-image>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="conclusion" width="100px" label="验收结论" align="center" header-align="center">
                  <template #default="{ row }">
                    <el-tooltip 
                      :content="row.conclusion" 
                      placement="top" 
                    >
                      <div class="multi-line-ellipsis">{{ row.conclusion }}</div>
                    </el-tooltip>
                  </template>
                </el-table-column>
              </el-table>
              <div style="display: flex;justify-content: flex-end;padding: 20px 10px 0px 20px;">
                <el-pagination v-model:current-page="currentPage" v-model:page-size="pageSize" :page-sizes="[10, 20, 40]" :size="size" :disabled="disabled" background layout="total, sizes, prev, pager, next, jumper" :total="total" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-dialog title="预览" v-model="preview" width="70%" top="5vh" append-to-body="true">
        <el-main>
            <div style="height:calc(70vh);">
            <iframe v-if="otherUrl" :src="otherUrl+'#view=FitH,top'" width="100%" height="100%" ></iframe>
            </div>
        </el-main>
      </el-dialog>
      <MyFooter />
    </div>
  </template>
  <script setup>
  import { ref, onMounted } from "vue";
  import MyBanner from "@/components/MyBanner.vue";
  import MyFooter from "@/components/MyFooter.vue";
  import { ArrowRight } from '@element-plus/icons-vue'
  import { useRouter } from "vue-router";
  import { pageFindConcealedWork } from "@/api/index.js"
  const router = useRouter();
  let Factive = ref(0)
  let preview = ref(false);
  let otherUrl = ref("");
  let downLoad = ref("");
  let concealedWorkList = ref([])
  let currentPage = ref(1)
  let current = ref(1)
  let pageSize = ref(10)
  let disabled = ref(false)
  let size = ref('default')
  let total = ref()
  let previewFile = (url) => {
    const extension = url.substring(url.lastIndexOf('.') + 1)
    downLoad.value = extension
    if (downLoad.value == 'pdf') {
      preview.value = true
    }
    if (url) {
        otherUrl.value = url
    } else {
        otherUrl.value = ''
    }
  }
  let handleSizeChange = (val) => {
    pageSize.value = val
    GetNewsTable()
  }
  let handleCurrentChange = (val) => {
    current.value = val
    GetNewsTable()
  }
  let GetNewsTable = async () => {
    await pageFindConcealedWork({ current: current.value, size: pageSize.value }).then(res => {
        concealedWorkList.value = res.data.data
        total.value = res.data.total
    })
  }
  onMounted(async () => {
    Factive.value = router.currentRoute.value.query.title ? router.currentRoute.value.query.title : router.currentRoute.value.query.str 
    GetNewsTable()
  });
  </script>
  <style scoped>
  ::v-deep .el-table thead th {
  font-size: 14px;
  height: 50px !important;
  padding: 0;
  font-weight: 700;
  color: rgba(0, 0, 0, 1);
  background: rgba(228, 228, 228, 1) !important;
}
::v-deep .el-table tr {
  height: 50px !important;
  font-size: 14px;
  color: #000;
}
::v-deep .el-table td.el-table__cell {
  border-bottom: none;
}
::v-deep .el-table--fit .el-table__inner-wrapper:before {
  width: 0;
}
  .w1200 {
    width: 1300px;
    margin: 0 auto;
  }
  .content {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
    padding: 20px;
    margin-bottom: 20px;
  }
  .box-content {
    height: calc(100% - 70px);
    padding: 20px;
    box-sizing: border-box;
  }
  .box-content-item {
    height: 24px;
    display: flex;
    justify-content: space-between;
    position: relative;
    margin-bottom: 27px;
    cursor: pointer;
  }
  .box-content-item:nth-last-child(1) {
    margin-bottom: 0;
  }
  .box-content-item::before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #999999;
  }
  .item-title {
    width: 80%;
    font-size: 16px;
    font-weight: 400;
    color: #444;
    margin-left: 15px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .item-time {
    width: 19%;
    text-align: right;
    font-size: 14px;
    font-weight: 400;
    color: rgba(136, 136, 136, 1);
  }
  .multi-line-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; /* 控制显示的行数 */
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all; /* 确保长单词或URL也能换行 */
  }
  </style>